import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.size.base,
    color: 'white'
  },

  tooltip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.25)',
    borderRadius: '8px',
    padding: '8px 16px',
    background: '#4A4A4A'
  },

  arrow: {
    color: '#4A4A4A'
  }
}))

export default useStyles
